import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Menu } from 'antd';
import Icon from 'component/icon';
import FavoritesIcon from './favoritesIcon';

const DropDownMenu = (props) => {
    const {
        pages,
        setIsMenuOpen,
        currentRouteName,
        onClickMenu,
        menuPosition,
        myFavorites,
        langConfig
    } = props;
    const [openKeys, setOpenKeys] = useState('');
    const [isDropDownOpen, setIsDropDownOpen] = useState(false);

    const groupKeys = useMemo(() => {
        const keys = pages?.map((pageGroup) => pageGroup.path || pageGroup.name) || [];
        if (myFavorites.open) {
            keys.push('favorites');
        }
        return keys;
    }, [pages, myFavorites]);

    const onChangeOpenKey = useCallback((keys) => {
        const key = keys?.[keys.length - 1] || '';
        if (groupKeys.includes(key)) {
            setOpenKeys([key]);
        } else if (key) {
            setOpenKeys([openKeys[0], key]);
        } else {
            setOpenKeys([]);
        }
    }, [groupKeys, openKeys]);

    useEffect(() => {
        const keys = [];
        pages?.forEach((pageGroup) => {
            pageGroup.children?.forEach((page) => {
                if (page.path === currentRouteName || pageGroup.name === currentRouteName) {
                    keys.push(pageGroup.path || pageGroup.name);
                } else if (page.children) {
                    const paths = page.children.map((subPage) => subPage.path);
                    if (paths.includes(currentRouteName)) {
                        keys.push(pageGroup.path || pageGroup.name);
                        keys.push(page.path || page.name);
                    }
                }
            });
        });
        setOpenKeys(keys);
    }, [pages, currentRouteName]);

    const handleDropDownOpen = () => {
        if (!(window.innerWidth <= 768)) {
            setIsDropDownOpen(true);
        }
    };

    const handleMenuOpen = () => {
        if (window.innerWidth <= 768) {
            setIsDropDownOpen(!isDropDownOpen);
        } else {
            setIsMenuOpen(true);
        }
    };

    const handleClickMenu = useCallback(({ key }) => {
        if (!key.includes('favorites-')) {
            onClickMenu?.(key);
        }
        setIsDropDownOpen(false);
    }, [onClickMenu, setIsDropDownOpen]);

    const dropDownMenuContent = useMemo(() => {
        const favoriteMenus = {
            key: 'favorites',
            label: langConfig?.favorite || '最愛',
            children: []
        };
        const addFavoritePages = (page) => {
            if (myFavorites.favoritePages.includes(page.key)) {
                favoriteMenus.children.push({
                    ...page,
                    key: `favorites-${page.key}`,
                    onClick: () => handleClickMenu({ key: page.key })
                });
            }
        };
        const dropDownMenus = pages?.map((pageGroup) => {
            const { path, name, children, icon } = pageGroup || {};
            const pageGroupObj = {
                key: path || (children?.length ? name : ''),
                label: name,
                children: children?.map((page) => {
                    const pageObj = {
                        key: page.path || (page.children?.length ? page.name : ''),
                        label: (
                            <div className="flex justify-between items-center">
                                <span>{page.name}</span>
                                {!page.children?.length && (
                                    <FavoritesIcon
                                        myFavorites={myFavorites}
                                        page={page.path}
                                        className="mr-3"
                                    />
                                )}
                            </div>
                        ),
                        children: page.children?.map((subPage) => {
                            const subPageObj = {
                                key: subPage.path || subPage.name,
                                label: (
                                    <div className="flex justify-between items-center">
                                        <span>{subPage.name}</span>
                                        <FavoritesIcon
                                            myFavorites={myFavorites}
                                            page={subPage.path}
                                            className="mr-3"
                                        />
                                    </div>
                                ),
                                icon: subPage.icon
                            };
                            addFavoritePages(subPageObj);
                            return subPageObj;
                        }),
                        icon: page.icon,
                        className: 'menu-layout'
                    };
                    addFavoritePages(pageObj);
                    return pageObj;
                }),
                icon
            };
            addFavoritePages(pageGroupObj);
            return pageGroupObj;
        });
        if (myFavorites.open && favoriteMenus.children.length) {
            dropDownMenus.push(favoriteMenus);
        }
        return (
            <Menu
                mode="inline"
                items={dropDownMenus}
                onClick={handleClickMenu}
                selectedKeys={[currentRouteName]}
                className="bg-menu border-r border-r-transparent rounded-md"
                onOpenChange={onChangeOpenKey}
                openKeys={openKeys}
                expandIcon={(menuProps) => (
                    <Icon
                        name={menuProps.isOpen ? 'expand_more' : 'chevron_right'}
                        size={20}
                        className
                    />
                )}
            />
        );
    }, [langConfig?.favorite, pages, currentRouteName, openKeys, onChangeOpenKey, handleClickMenu, myFavorites]);

    const iconMap = {
        left: 'keyboard_double_arrow_right',
        top: 'keyboard_double_arrow_down'
    };

    return (
        <div className="h-full" onMouseLeave={() => setIsDropDownOpen(false)}>
            <div className="h-full relative z-10 flex items-center">
                <Icon
                    name={isDropDownOpen ? iconMap[menuPosition] : 'menu'}
                    size={24}
                    onMouseEnter={() => handleDropDownOpen(true)}
                    onClick={handleMenuOpen}
                    className="cursor-pointer text-menu-selected dark:text-white"
                />
            </div>
            {isDropDownOpen && (
                <div className="absolute top-0 left-2 min-w-[200px] h-screen">
                    <div className="translate-y-[50px] h-[calc(100%_-_50px)] overflow-auto hidden-scrollbar rounded-md">
                        {dropDownMenuContent}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownMenu;
